var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.7541 36.7319H11.4426V16.8421H16.7541V36.7319ZM14.0984 14.5494C12.3881 14.5494 11 13.1209 11 11.3598C11 9.59861 12.3881 8.17017 14.0984 8.17017C15.8087 8.17017 17.1967 9.59861 17.1967 11.3598C17.1967 13.1209 15.8104 14.5494 14.0984 14.5494ZM38 36.7319H32.6885V26.599C32.6885 20.5091 25.6066 20.9701 25.6066 26.599V36.7319H20.2951V16.8421H25.6066V20.0335C28.0782 15.3576 38 15.0123 38 24.5105V36.7319Z","fill":"white","key":0}),React.createElement("path",{"d":"M9.79167 1.5H37.2083C41.759 1.5 45.5 5.2763 45.5 10V38C45.5 42.7237 41.759 46.5 37.2083 46.5H9.79167C5.24275 46.5 1.5 42.7235 1.5 38V10C1.5 5.2765 5.24275 1.5 9.79167 1.5Z","stroke":"white","strokeWidth":"3","key":1})]);
}

LinkedinIcon.defaultProps = {"width":"47","height":"48","viewBox":"0 0 47 48","fill":"none"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
